import Cookies from "js-cookie";

type TToken = {
  access: {
    token: string;
    expires: string;
  };
  refresh: {
    token: string;
    expires: string;
  };
};

type TUserSession = {
  rememberMe: boolean;
  token: TToken;
  user: string;
};

const isSecure = window.location.protocol === "https:";

const cookieOptions = (expires: number): Cookies.CookieAttributes => ({
  expires,
  secure: isSecure,
  sameSite: "Strict",
});

export const setUserSession = ({ rememberMe, token, user }: TUserSession) => {
  const daysToExpire = rememberMe ? 30 : 1;
  Cookies.set("token", JSON.stringify(token), cookieOptions(daysToExpire));
  Cookies.set("user", JSON.stringify(user), cookieOptions(daysToExpire));
  return true;
};

// return the user data from the cookies
export const getUser = () => {
  const userStr = Cookies.get("user");
  if (userStr) {
    return JSON.parse(userStr);
  }
  return null;
};

// return the token from the cookies
export const getToken = (): TToken | null => {
  const token = Cookies.get("token");
  return token ? JSON.parse(token) : null;
};

// remove all session cookies (token, user, rememberMe)
export const removeUserSession = () => {
  Cookies.remove("token");
  Cookies.remove("user");
  Cookies.remove("rememberMe");
};

// return the remember me value from the cookies
export const getRememberMe = () => Cookies.get("rememberMe") || null;

// update and save the token into the cookies
export const setToken = (token: TToken, expires: number) => {
  Cookies.set("token", JSON.stringify(token), cookieOptions(expires));
};

export const setToast = (isToast: unknown) => {
  Cookies.set("toast", JSON.stringify(isToast), { expires: 1 });
};

export const getToast = () => Cookies.get("toast") || null;

export const removeToast = () => {
  Cookies.remove("toast");
};
